export default () => ({
	globalLoading: false,
	invoice: [],
	loading: false,
	message: '',
	profile: {},
	profileUser: null,
	refreshToken: null,
	sharingWithMeEmails: [],
	token: null,
	users: [],
	userSharingEmails: [],
});
